import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';

const TeamCampaignsHeader = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>
                Campaigns
            </Typography>
            <Button variant="contained" startIcon={<AddIcon />}>
                Create Campaign
            </Button>
        </Box>
    );
};

export default TeamCampaignsHeader;

